import { el, setChildren } from 'redom';

import { stringToSVG } from 'utilities';

import ProfilePictureDisplay from 'root/startup-view/inbox/profile-picture-display';

import {
  determineAttendeeLabel,
  convertAttendeeStatusToText
} from './utilities';

import closeButtonIconString from 'assets/images/close-button-icon.svg?raw';

const closeButtonIcon = stringToSVG(closeButtonIconString);

class MeetingAttendee {

  constructor(meetingAttendees) {

    this.meetingAttendees = meetingAttendees;

    this.profilePictureDisplay = new ProfilePictureDisplay();
    this.nameDisplay = el('label.calendar-activity-entry-name');
    this.attendeeLabelDisplay = el('label.calendar-activity-entry-attendee-label.application-sub-text');
    this.nameAndLabel = el('label', [this.nameDisplay, this.attendeeLabelDisplay]);
    this.statusLabel = el('label.application-sub-text');
    this.uninviteButton = el('button', {
      class: 'application-button round-button attendee-uninvite-button',
      onclick: this.handleUnviteButtonClick.bind(this)
    }, [closeButtonIcon.cloneNode(true)]);

    this.el = el('.meeting-attendee-main');

  }

  handleUnviteButtonClick() {

    this.meetingAttendees.uninviteAttendee(this.attendee);

  }

  update(attendee, index, attendees, context) {

    this.attendee = attendee;

    const elements = [];

    this.profilePictureDisplay.update(attendee);
    this.nameDisplay.textContent = attendee.fullName;
    this.statusLabel.textContent = convertAttendeeStatusToText(this.attendee.status);

    const label = determineAttendeeLabel(attendee, context.event.creatorId, context.currentUser._id);

    if (label !== null) {
      this.attendeeLabelDisplay.textContent = ` (${label})`;
    }

    elements.push(this.profilePictureDisplay);
    elements.push(this.nameAndLabel);
    elements.push(this.statusLabel);

    if (context.event.creatorId === context.currentUser._id && this.attendee._id !== context.currentUser._id) {
      elements.push(this.uninviteButton);
    }

    setChildren(this.el, elements);

  }

}

export default MeetingAttendee;